import app from '../app';

export const CADASTRAL_NUMBER_REGEXP = /[^\d:]+/ig;

app.directive('cianAfCadastralNumber', () => {
  return {
    priority: 1,
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attrs, ngModel) => {
      const keepCadastralNumber = (number) => {
        number = String(number);

        const cleanNumber = (number || '').replace(CADASTRAL_NUMBER_REGEXP, '');

        if (cleanNumber !== number) {
          ngModel.$setViewValue(cleanNumber);
          element.val(cleanNumber);
        }

        return cleanNumber;
      };

      ngModel.$parsers.unshift(keepCadastralNumber);
    },
  };
});
